import { render } from "./infiniteScroll.vue?vue&type=template&id=f1ecc39e&scoped=true"
import script from "./infiniteScroll.vue?vue&type=script&lang=js"
export * from "./infiniteScroll.vue?vue&type=script&lang=js"

import "./infiniteScroll.vue?vue&type=style&index=0&id=f1ecc39e&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ecc39e"]])

export default __exports__